'use client';

import React from 'react';
import { usePathname } from 'next/navigation';

/**
 * Re-keys its children on every route change so the page replays a fade-in.
 * Uses opacity only — a transform on this wrapper would re-base the fixed
 * header/backdrop inside it, so the transition is a clean cross-fade.
 */
export default function PageTransition({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  return (
    <div key={pathname} className="page-transition">
      {children}
    </div>
  );
}
